import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { isValidHttpUrl } from 'src/utils/url';

export const BackgroundImagePreview = ({ url }: { url: string }) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [url]);

  if (!url || !isValidHttpUrl(url) || hasError) return null;

  return (
    <Box
      component="img"
      src={url}
      alt="Background preview"
      onError={() => setHasError(true)}
      sx={{
        width: '100%',
        maxHeight: 160,
        objectFit: 'contain',
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
      }}
    />
  );
};
